import { aiOutlineOptions } from '../../../../constants/aiOptimizerConstants';
import { OUTLINE_AI_HEADINGS_LIMIT } from '../constants/aiEditorConstants';

export const isWithinHeadingCountLimit = (total) => {
    if (!total) return false;

    return total > 0 && total <= OUTLINE_AI_HEADINGS_LIMIT;
};

export const hasRequiredHeadings = (headingCount) => {
    const { h1 = 0, h2 = 0 } = headingCount || {};

    return h1 > 0 && h2 > 0;
};

export const validateHeadingRequirements = (headingCount) => {
    if (!headingCount) {
        return { isValid: false, message: null };
    }

    if (!hasRequiredHeadings(headingCount)) {
        return {
            isValid: false,
            message: (
                <>
                    <b>To generate AI content:</b> First create an outline yourself or by clicking "
                    {aiOutlineOptions.newOutline.label}" button. An H1 and H2 heading is required.
                </>
            ),
        };
    }

    if (!isWithinHeadingCountLimit(headingCount.total)) {
        return {
            isValid: false,
            message: (
                <>
                    Your outline exceeds the
                    <br />
                    <b> {OUTLINE_AI_HEADINGS_LIMIT}-heading limit</b> for AI-generated content.
                    Please reduce the total number of headings (H2, H3, etc) and try again.
                </>
            ),
        };
    }

    return { isValid: true, message: null };
};
